import { UserStatus, IGetUsersListDTO } from '@/models/users.model';
import { TUserFiltersValues, UserFiltersFields } from '../helpers/types';

class GetUsersListDTO implements IGetUsersListDTO {
  full_name?: string;
  email?: string;
  phone_number?: string;
  address?: string;
  cursor?: string;
  limit?: number;
  status?: UserStatus;
  tripletex_customer_number?: string;

  constructor(values: TUserFiltersValues) {
    this.status = values[UserFiltersFields.STATUS];
    this.full_name = values[UserFiltersFields.NAME];
    this.phone_number = values[UserFiltersFields.PHONE_NUMBER];
    this.email = values[UserFiltersFields.EMAIL];
    this.address = values[UserFiltersFields.ADDRESS];
    this.limit = values?.limit ?? 10;
    this.cursor = values[UserFiltersFields.CURSOR];
    this.tripletex_customer_number = values[UserFiltersFields.TRIPLETEX_CUSTOMER_NUMBER];
  }
}

export default GetUsersListDTO;
